import { iconSetMaterial, themeQuartz } from 'ag-grid-community';

// to use myTheme in an application, pass it to the theme grid option
export const customAgGridTheme = themeQuartz.withPart(iconSetMaterial).withParams({
    accentColor: 'var(--p-primary-color)',
    backgroundColor: 'var(--p-surface-card)',
    borderColor: 'var(--p-surface-border)',
    borderRadius: 4,
    browserColorScheme: 'inherit',
    cellHorizontalPaddingScale: 0.7,
    checkboxBorderRadius: 2,
    checkboxUncheckedBackgroundColor: 'var(--p-surface-ground)',
    chromeBackgroundColor: 'var(--p-surface-card)',
    columnBorder: false,
    columnDropCellBackgroundColor: 'var(--p-highlight-background)',
    columnDropCellBorder: true,
    fontFamily: {
        googleFont: 'Roboto'
    },
    fontSize: 12,
    foregroundColor: 'var(--p-text-color)',
    headerBackgroundColor: 'var(--p-highlight-background)',
    headerColumnResizeHandleColor: 'var(--p-highlight-focus-background)',
    headerColumnResizeHandleHeight: '100%',
    headerColumnResizeHandleWidth: 1,
    headerFontFamily: {
        googleFont: 'Roboto'
    },
    headerFontSize: 12,
    headerFontWeight: 700,
    headerRowBorder: '1px solid var(--p-highlight-focus-background)',
    headerTextColor: 'var(--p-text-color)',
    iconColor: 'var(--p-primary-color)',
    iconSize: 16,
    inputBackgroundColor: 'var(--p-surface-ground)',
    inputBorderRadius: 4,
    inputBorder: '1px solid var(--p-surface-border-darker)',
    rowBorder: true,
    rowVerticalPaddingScale: 0.8,
    sideBarPanelWidth: 250,
    sidePanelBorder: true,
    spacing: 4,
    wrapperBorder: false,
    wrapperBorderRadius: 4
});
